import axios from 'axios';
import { SocialPost } from '@/modules/market-signals/model/social-media';

export function parseIncomingSocialPost(post: any): SocialPost {
  const raw = post?.body ?? post;

  const tempElement = document.createElement('div');
  tempElement.innerHTML = raw?.content || '';
  const plainText = tempElement.textContent || tempElement.innerText || '';

  return {
    id: raw.id,
    content: plainText.trim(),
    createdAt: new Date(raw.initialPostDate),
    mediaAttachments: Array.isArray(raw.mediaAttachments) ? raw.mediaAttachments : [],
    network: raw.network,
    author: raw.author,
  };
}

async function getHistory<T>(topic: string, page: string): Promise<T[]> {
  const url = `/api/messaging/history?destination=/topic/${topic}&page=${encodeURIComponent(page)}`;
  const response = await axios.get(url);
  return response.data.content;
}

const socialPostApi = {
  getHistory,
};

export default socialPostApi;
